module.exports = __webpack_public_path__ + "media/003.e34eac6b.mp4";